import moment from 'moment';
import {
  DEFAULT_INTERVAL_MINUTES,
  generateTimeOptions,
  getSuggestedOptionId
} from 'UI/components/molecules/TimeSelect';

const MINUTES_IN_HOUR = 60;
const DEFAULT_RANGE_SLOTS = MINUTES_IN_HOUR / DEFAULT_INTERVAL_MINUTES;

export const getSuggestedInterviewTimes = now => {
  const options = generateTimeOptions();
  const from = getSuggestedOptionId(options, now);
  const currentTime = (now || moment()).format('HH:mm');
  const fromIndex = options.findIndex(option => option.id === from);
  const to = options[fromIndex + DEFAULT_RANGE_SLOTS]?.id ?? null;

  return from >= currentTime && to ? { from, to } : { from: null, to: null };
};
